/**
 * ROWEM theme interactions — no AOS CDN.
 * Uses IntersectionObserver to add .aos-animate to [data-aos] elements.
 */
(function () {
  'use strict';

  /* Lightweight AOS replacement */
  function initAos() {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = document.querySelectorAll('[data-aos]');

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('aos-animate');
      });
      return;
    }

    document.querySelectorAll('[data-aos-order]').forEach(function (el) {
      var order = parseInt(el.getAttribute('data-aos-order'), 10) || 1;
      el.setAttribute('data-aos-delay', String((order - 1) * 60));
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-aos-delay'), 10) || 0;
          if (delay) {
            setTimeout(function () {
              el.classList.add('aos-animate');
            }, delay);
          } else {
            el.classList.add('aos-animate');
          }
          observer.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -40px 0px', threshold: 0.08 }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* Header fade on load */
  var header = document.querySelector('[data-header]');
  if (header) {
    requestAnimationFrame(function () {
      header.classList.add('is-visible');
    });
  }

  /* Mobile drawer */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuClose = document.querySelector('[data-menu-close]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var menuOverlay = document.querySelector('[data-menu-overlay]');

  function openMenu() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (menuOverlay) menuOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    mobileNav.querySelectorAll('[data-drawer-item]').forEach(function (item, i) {
      item.style.animationDelay = 150 + i * 50 + 'ms';
      item.classList.add('is-animated');
    });
  }

  function closeMenu() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (menuOverlay) menuOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
    mobileNav.querySelectorAll('[data-drawer-item]').forEach(function (item) {
      item.classList.remove('is-animated');
    });
  }

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  /* Collection page filters */
  var collectionGrid = document.querySelector('[data-collection-grid]');
  if (collectionGrid) {
    var collectionTabs = document.querySelectorAll('[data-collection-filter]');
    var collectionSearch = document.querySelector('[data-collection-search]');
    var collectionResults = document.querySelector('[data-collection-results]');
    var collectionSort = document.querySelector('[data-collection-sort]');
    var collectionItems = Array.from(collectionGrid.querySelectorAll('[data-category]'));
    var filterPanel = document.querySelector('[data-collection-filters]');
    var filterToggle = document.querySelector('[data-filter-toggle]');
    var filterClose = document.querySelector('[data-filter-close]');
    var filterOverlay = document.querySelector('[data-filter-overlay]');
    var activeFilter = 'all';

    function openFilterPanel() {
      if (!filterPanel) return;
      filterPanel.classList.add('is-open');
      if (filterOverlay) filterOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeFilterPanel() {
      if (!filterPanel) return;
      filterPanel.classList.remove('is-open');
      if (filterOverlay) filterOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (filterToggle) filterToggle.addEventListener('click', openFilterPanel);
    if (filterClose) filterClose.addEventListener('click', closeFilterPanel);
    if (filterOverlay) filterOverlay.addEventListener('click', closeFilterPanel);

    function getSearchQuery() {
      return collectionSearch ? collectionSearch.value.trim().toLowerCase() : '';
    }

    function itemMatchesFilters(item) {
      var category = item.getAttribute('data-category');
      var searchText = (item.getAttribute('data-search-text') || '').toLowerCase();
      var query = getSearchQuery();
      if (activeFilter !== 'all' && category !== activeFilter) return false;
      if (query && searchText.indexOf(query) === -1) return false;
      return true;
    }

    function sortCollectionItems() {
      if (!collectionSort) return;
      var sortValue = collectionSort.value;
      if (sortValue === 'default') return;

      var visibleItems = collectionItems.filter(function (item) {
        return !item.classList.contains('is-hidden');
      });

      visibleItems.sort(function (a, b) {
        var titleA = (a.getAttribute('data-sort-title') || '').toLowerCase();
        var titleB = (b.getAttribute('data-sort-title') || '').toLowerCase();
        if (titleA < titleB) return sortValue === 'title-asc' ? -1 : 1;
        if (titleA > titleB) return sortValue === 'title-asc' ? 1 : -1;
        return 0;
      });

      visibleItems.forEach(function (item) {
        collectionGrid.appendChild(item);
      });
    }

    function refreshCollection(options) {
      options = options || {};
      var visible = 0;

      collectionItems.forEach(function (item) {
        var show = itemMatchesFilters(item);
        item.classList.toggle('is-hidden', !show);
        if (show) visible += 1;
      });

      collectionTabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-collection-filter') === activeFilter;
        tab.classList.toggle('is-active', isActive);
        if (tab.getAttribute('role') === 'tab') {
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        }
      });

      if (collectionResults) {
        if (visible === 0) {
          collectionResults.textContent = 'No products found';
        } else {
          collectionResults.textContent = 'Results: 1 – ' + visible + ' of ' + visible + ' Products';
        }
      }

      sortCollectionItems();
      if (options.closePanel !== false) closeFilterPanel();
    }

    function applyCollectionFilter(filter, options) {
      activeFilter = filter || 'all';
      refreshCollection(options);
    }

    collectionTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var filter = tab.getAttribute('data-collection-filter') || 'all';
        applyCollectionFilter(filter);
        if (filter === 'all') {
          history.replaceState(null, '', window.location.pathname);
        } else {
          history.replaceState(null, '', '#' + filter);
        }
      });
    });

    if (collectionSearch) {
      collectionSearch.addEventListener('input', function () {
        refreshCollection({ closePanel: false });
      });
    }

    if (collectionSort) {
      collectionSort.addEventListener('change', sortCollectionItems);
    }

    var hash = window.location.hash.replace('#', '');
    if (
      hash &&
      collectionItems.some(function (item) {
        return item.getAttribute('data-category') === hash;
      })
    ) {
      applyCollectionFilter(hash, { closePanel: false });
    } else {
      applyCollectionFilter('all', { closePanel: false });
    }
  }

  /* Marquee is pure CSS now — no JS width measuring / DOM cloning */

  /* Text with icons — mobile carousel */
  document.querySelectorAll('[data-text-with-icons]').forEach(function (carousel) {
    var items = Array.from(carousel.querySelectorAll('.text-with-icons__item'));
    var section = carousel.closest('.shopify-section--text-with-icons') || carousel.closest('.shopify-section');
    var dots = section
      ? Array.from(section.querySelectorAll('[data-icons-dot]'))
      : Array.from(document.querySelectorAll('[data-icons-dot]'));
    var currentIndex = 0;
    var mobileQuery = window.matchMedia('(max-width: 699px)');
    var touchStartX = 0;
    var timer;

    function selectItem(index) {
      index = Math.max(0, Math.min(index, items.length - 1));
      if (index === currentIndex) return;
      currentIndex = index;
      items.forEach(function (item, i) {
        item.classList.toggle('is-selected', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function startAutoplay() {
      clearInterval(timer);
      if (!mobileQuery.matches) return;
      timer = setInterval(function () {
        selectItem((currentIndex + 1) % items.length);
      }, 5000);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        selectItem(parseInt(dot.getAttribute('data-icons-dot'), 10) || 0);
        startAutoplay();
      });
    });

    carousel.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.touches[0].clientX;
      },
      { passive: true }
    );

    carousel.addEventListener(
      'touchend',
      function (e) {
        if (!mobileQuery.matches) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 48) {
          selectItem(currentIndex + (dx < 0 ? 1 : -1));
          startAutoplay();
        }
      },
      { passive: true }
    );

    mobileQuery.addEventListener('change', startAutoplay);
    startAutoplay();
  });

  /* Instagram feed load more */
  document.querySelectorAll('[data-insta-feed]').forEach(function (feed) {
    var loadMoreBtn = feed.querySelector('[data-insta-load-more]');
    var hiddenItems = Array.from(feed.querySelectorAll('.ti-widget-item--hidden'));
    if (!loadMoreBtn || !hiddenItems.length) {
      if (loadMoreBtn) loadMoreBtn.classList.add('is-hidden');
      return;
    }

    loadMoreBtn.addEventListener('click', function () {
      hiddenItems.forEach(function (item) {
        item.hidden = false;
        item.classList.remove('ti-widget-item--hidden');
      });
      loadMoreBtn.classList.add('is-hidden');
    });
  });

  /* FAQ accordion — one open at a time */
  document.querySelectorAll('[data-faq-accordion]').forEach(function (accordion) {
    accordion.querySelectorAll('.rowem-faq__item').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        accordion.querySelectorAll('.rowem-faq__item').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  });

  /* Product tabs */
  document.querySelectorAll('[data-product-tabs]').forEach(function (tabs) {
    var buttons = tabs.querySelectorAll('[data-product-tab]');
    var panels = tabs.querySelectorAll('[data-product-panel]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-product-tab');
        buttons.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-product-panel') === id;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });
    });
  });

  /* 10% off newsletter popup — index only; stays open after success until X */
  function initNewsletterPopup() {
    var root = document.querySelector('[data-newsletter-popup]');
    if (!root) return;
    if (!document.body.classList.contains('template-index')) return;

    var subscribedKey = 'rowem-nl-subscribed-rowem10';
    var seenKey = 'rowem-nl-seen-session-rowem10';
    var delayMs = Number(root.getAttribute('data-delay') || 2500);
    var previouslyFocused = null;
    var form = root.querySelector('#newsletter-popup form') || root.querySelector('form');
    var success = root.querySelector('[data-newsletter-success]');
    var emailInput = root.querySelector('[data-newsletter-email]') || root.querySelector('#nl-popup-email');
    var code = root.getAttribute('data-welcome-code') || 'ROWEM10';
    var closeBtn = root.querySelector('.nl-popup__close');

    function hasSubscribed() {
      try {
        return window.localStorage.getItem(subscribedKey) === '1';
      } catch (err) {
        return false;
      }
    }
    function markSubscribed() {
      try {
        window.localStorage.setItem(subscribedKey, '1');
      } catch (err) {}
    }
    function hasSeenThisSession() {
      try {
        return window.sessionStorage.getItem(seenKey) === '1';
      } catch (err) {
        return false;
      }
    }
    function markSeenThisSession() {
      try {
        window.sessionStorage.setItem(seenKey, '1');
      } catch (err) {}
    }
    function showSuccess() {
      root.classList.add('is-success');
      if (success) {
        success.hidden = false;
        var codeEl = success.querySelector('[data-welcome-code-display]');
        if (codeEl) codeEl.textContent = code;
      }
      if (form) {
        form.setAttribute('hidden', '');
        form.setAttribute('aria-hidden', 'true');
      }
      markSubscribed();
      /* Stay open — only the X closes it */
      if (closeBtn) closeBtn.focus();
    }
    function openPopup() {
      if (root.classList.contains('is-open')) return;
      previouslyFocused = document.activeElement;
      root.removeAttribute('hidden');
      root.hidden = false;
      void root.offsetWidth;
      root.classList.add('is-open');
      document.body.classList.add('is-nl-popup-open');
      window.setTimeout(function () {
        if (emailInput && !root.classList.contains('is-success')) emailInput.focus();
      }, 40);
    }
    function closePopup() {
      if (!root.classList.contains('is-open') && root.hidden) return;
      root.classList.remove('is-open');
      document.body.classList.remove('is-nl-popup-open');
      markSeenThisSession();
      window.setTimeout(function () {
        root.hidden = true;
        root.setAttribute('hidden', '');
        if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
          previouslyFocused.focus();
        }
      }, 320);
    }

    /* Only the X button dismisses (not backdrop), so the code stays visible */
    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        closePopup();
      });
    }

    function handleSubscribe(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (!form) return false;
      if (typeof form.reportValidity === 'function' && !form.checkValidity()) {
        form.reportValidity();
        return false;
      }
      showSuccess();
      try {
        var action = form.getAttribute('action') || window.location.pathname;
        var formData = new FormData(form);
        window.fetch(action, {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          redirect: 'manual'
        }).catch(function () {});
      } catch (err) {}
      return false;
    }

    if (form) {
      form.setAttribute('novalidate', '');
      form.addEventListener('submit', handleSubscribe, true);
      var submitBtn = form.querySelector('[data-newsletter-submit]');
      if (submitBtn) {
        submitBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          handleSubscribe(event);
        });
      }
    }

    document.addEventListener('keydown', function (event) {
      if (!root.classList.contains('is-open')) return;
      /* Escape only closes via same intentional dismiss path as X */
      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup();
      }
    });

    if (hasSubscribed() || hasSeenThisSession()) return;
    window.setTimeout(openPopup, delayMs);
  }

  /* Pause heavy motion while offscreen so scrolling stays smooth */
  function initOffscreenMotionPause() {
    if (!('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('[data-hero-slideshow], .announcement-marquee');
    if (!targets.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);
        });
      },
      { rootMargin: '80px 0px', threshold: 0 }
    );
    targets.forEach(function (el) {
      io.observe(el);
    });
  }

  initAos();
  initNewsletterPopup();
  initOffscreenMotionPause();
})();
